module.exports = __webpack_public_path__ + "img/icon6.180c786f.png";